import React from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import PasswordForm from '../../components/profile/PasswordForm';
import { useProfile } from '../../hooks/useProfile';
import { theme } from '../../config/theme';

const AdminSettings = () => {
  const { changePassword, loading } = useProfile();

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold, 
          marginBottom: theme.spacing.xl 
        }}>
          Admin Settings
        </h1>
        <PasswordForm onSubmit={changePassword} loading={loading} />
      </div>
    </MainLayout>
  );
};

export default AdminSettings;